import { useEffect } from 'react';
import { UserManager } from 'oidc-client-ts';
import { createAuthConfig } from '../authConfig';

export function SilentRenew() {
  useEffect(() => {
    const handleSilentRenew = async () => {
      try {
        const userManager = new UserManager(createAuthConfig());
        await userManager.signinSilentCallback();
      } catch (error) {
        console.error('Silent renewal callback error:', error);
      }
    };

    handleSilentRenew();
  }, []);

  // This component is loaded in an iframe, so no visible UI needed
  return null;
}
